import { WarningAmber as WarningIcon } from '@mui/icons-material';

interface ScannerWarningAlertProps {
  message?: string;
}

const ScannerWarningAlert = ({
  message = 'Por favor, verifique si seleccionó el conductor correcto y que los pedidos correspondan a este conductor antes de comenzar a escanear.',
}: ScannerWarningAlertProps) => {
  return (
    <div className='flex items-center gap-4 p-5 rounded-xl bg-orange-50 border border-orange-200 mt-4 mb-2'>
      <div className='text-orange-600 shrink-0'>
        <WarningIcon sx={{ fontSize: 28 }} />
      </div>
      <p className='text-orange-900 text-[14px] font-bold leading-relaxed'>
        {message}
      </p>
    </div>
  );
};

export default ScannerWarningAlert;
